export default {
    key: 'p2p',
    type: 'P2P',
    isUsingProductConfigPresets: true,
    isUsingProductPresets: false,
    hideCrossSells: false,
    disablePassengers: false,
    origins: [],
    destinations: [],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: 'optional',
    canSwitchDirection: true,
    canChooseReturnDestination: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: false,
    routeVariants: [],
    routeVariantUp: undefined,
    routeVariantDown: undefined,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: undefined,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 120,
    stayDurationMin: 60,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: undefined,
    isLocalListing: false,
    steps: [
        {
            routeName: 'offerFlow-p2p-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-p2p-steps-step-2-trip-selection',
            name: 'offerFlow.pages.stepTripSelection.name.common',
        },
        {
            routeName: 'offerFlow-p2p-steps-step-4-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
        },
    ],
} satisfies ProductConfigP2P;
